const getFormattedDate = (dateStr) => {
    if (!dateStr || dateStr.length !== 8) return "";
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    const day = dateStr.slice(6, 8);
    return `${year}-${month}-${day}`;
};

export {
    getFormattedDate
}